import React from 'react';
import '../footer.css';

function Footer() {
    return (
        <div className="footer">
            <p>© 2021 Hulu Rebuild - No Rights Reserved - Demo App</p>
            <p>Privacy | Terms | Sitemap | Company Details</p>
        </div>
    )
}

export default Footer
